import appAuthRoutes from "@/modules/auth/app_auth_routes";
import authRoutes from "@/modules/auth/auth_routes";
import dashboardRoutes from "@/modules/dashboard/routes";
import { IS_AUTH_BUILD_TARGET } from "@/config/index.js";

// routes for OBIADO app are set here
const tenant = [
  {
    path: "/:catchAll(.*)",
    redirect: "/dashboard",
  },
  {
    // Public external bulk order form — no auth required (no meta.roles)
    path: "/externalBulkOrders/:token",
    name: "externalBulkOrders.form",
    component: () => import("@/modules/orders/views/ExternalBulkOrderPublicForm.vue"),
  },
  ...dashboardRoutes,
  // redirect to login etc
  ...appAuthRoutes,
];

// routes for login page ( auth module ) are set here
const auth = [
  {
    path: "/:catchAll(.*)",
    redirect: "/auth/login",
  },
  // actual login etc
  ...authRoutes,
];

export const getRoutes = function () {
  if (IS_AUTH_BUILD_TARGET) {
    return auth;
  } else {
    return tenant;
  }
};
